/*工资发放明细 */
import { $http } from "./index";

//获取工资发放明细列表
export const salaryrecordemployee_list = (params) => {
  return $http.get("/admin/SalaryRecordEmployee/index", { params });
};

//导出
export const salaryrecordemployee_export = (params) => {
  return $http.get("/admin/SalaryRecordEmployee/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
